import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import '@shared/styles/tailwind.css';
import '@shared/styles/App.css';
import '@shared/styles/global.css';

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
